import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const MarkAsSpamModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "MarkAsSpamModalContainer" */
      './MarkAsSpamModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
